import { tokenUnavailable } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(tokenUnavailable, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (sharingLink) {
        sharingLink.accessTokenAvailable = false;
    }
});
